'use strict';

import * as venueList from '../actions/venueList';

var defaultState = {
    isEditVenueOverlayOpen: false,
    isDeleteVenueOverlayOpen: false,
    isNewVenueOverlayOpen: false,
    venues: [],
    formMode: 'add',
    venueToEdit: null,
    venueToDelete: null,
    markerSettings: {
        position: null
    },
    mapSettings: {
        defaultZoom: 5,
        defaultCenter: {
            lat: 52.456009,
            lng: -1.582031
        },
        defaultOptions: {
            mapTypeControl: true,
            streetViewControl: true
        }
    },
    defaultForm: {
        id: 0,
        address: {
            address_1: '',
            address_2: '',
            town_city: '',
            post_code: '',
            latitude: null,
            longitude: null
        }
    }
};

export default function(state = defaultState, action) {

    switch (action.type) {

        case venueList.VENUE_LOCATION_RESOLVED:

            return Object.assign({}, state, {
                markerSettings: {
                    position: {
                        lat: action.latitude,
                        lng: action.longitude
                    }
                },
                mapSettings: {
                    zoom: 17,
                    center: {
                        lat: action.latitude,
                        lng: action.longitude
                    },
                    defaultOptions: {
                        mapTypeControl: true,
                        streetViewControl: true
                    }
                }
            });

        case venueList.SHOW_EDIT_VENUE_OVERLAY:

            const { latitude, longitude } = action.venue.address;

            var venuePosition = null,
                zoom = defaultState.mapSettings.defaultZoom;

            if (latitude && longitude) {

                venuePosition = {
                    lat: parseFloat(latitude),
                    lng: parseFloat(longitude)
                };

                zoom = 17;
            }

            return Object.assign({}, state, {
                isEditVenueOverlayOpen: true,
                venueToEdit: action.venue,
                formMode: 'edit',
                markerSettings: {
                    position: venuePosition
                },
                mapSettings: {
                    zoom: zoom,
                    center: venuePosition || defaultState.mapSettings.defaultCenter,
                    defaultOptions: {
                        mapTypeControl: true,
                        streetViewControl: true
                    }
                }
            });

        case venueList.HIDE_EDIT_VENUE_OVERLAY:

            return Object.assign({}, state, {
                isEditVenueOverlayOpen: false,
                venueToEdit: null,
                mapSettings: defaultState.mapSettings,
                markerSettings: defaultState.markerSettings
            });

        case venueList.HIDE_DELETE_VENUE_OVERLAY:

            return Object.assign({}, state, {
                venueToDelete: null,
                isDeleteVenueOverlayOpen: false
            });

        case venueList.SHOW_DELETE_VENUE_OVERLAY:

            return Object.assign({}, state, {
                venueToDelete: action.venue,
                isDeleteVenueOverlayOpen: true
            });

        case venueList.VENUES_REFRESHED:

            return Object.assign({}, state, {
                venues: action.venues
            });

        case venueList.HIDE_NEW_VENUE_OVERLAY:

            return Object.assign({}, state, {
                isNewVenueOverlayOpen: false,
                mapSettings: defaultState.mapSettings,
                markerSettings: defaultState.markerSettings
            });

        case venueList.SHOW_NEW_VENUE_OVERLAY:

            return Object.assign({}, state, {
                isNewVenueOverlayOpen: true,
                formMode: 'add'
            });

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./reducers/venueList.js